import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import Portfolio from "./pages/Portfolio";
import WhyChooseUs from "./pages/WhyUse";
import TrustedPartners from "./pages/Partners";

function App() {
  return (
    // <Router>
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-grow">
        {/* <Home /> */}
        <About />
        <Services />
        <Testimonials />
        <WhyChooseUs />
        <Portfolio />
        <TrustedPartners />
        <Contact />

        {/* <Routes>
            <Route exact path="/" element={Home} />
            <Route path="/services" element={Services} />
            <Route path="/about" element={About} />
            <Route path="/contact" element={Contact} />
          </Routes> */}
      </div>
      <Footer />
    </div>
    // </Router>
  );
}

export default App;
